import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import Modal from "react-modal";
import { toast } from "react-toastify";
import moment from "moment";

const LabTestingForm = (props) => {
  const [loading, setLoading] = useState(false);

  const modalStyles2 = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "900px",
      maxHeight: "500px",

      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const frmRef = useRef({});
  function getCurrentTime() {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    hours = hours.toString().padStart(2, "0");
    minutes = minutes.toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const observationRef = useRef({});
  const [ObservationDetails, setObservationDetails] = useState([]);
  const [isObservationOpen, setIsObservationOpen] = useState(false);

  const [finishProducts, setFinishProducts] = useState([]);
  const [selectedResult, setSelectedResult] = useState("");

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [units, setUnits] = useState(false);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);

  const [lotData, setlotData] = useState([]);

  const { sendRequest: getLot } = useHttp();

  useEffect(() => {
    const data = {
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      process: "LT",
    };
    getLot(
      {
        url: "/api/getStockLotForPackhouseProcess/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);

        setlotData(data);
      }
    );
  }, [getLot]);
  const handleAttachmentChange = (e) => {
    const files = e.target.files;
      const attachmentFolder=localStorage.getItem("attachmentFolder");

    const picDataArray = Array.from(files).map((file) => {
      const uniqueFilename = `${new Date().valueOf()}/${file.name}`;
      const picData = new FormData();
      picData.append("fileUpload", file, uniqueFilename);
      return picData;
    });

    const uploadedFilesData = [];

    Promise.all(
      picDataArray.map((picData) =>
        fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/api/file/${attachmentFolder}/LabTest/${new Date().valueOf()}}`,
          {
            method: "POST",
            body: picData,
          }
        )
          .then((res) => res.json())
          .then((data) => {
            uploadedFilesData.push(data.url);
          })
      )
    )
      .then(() => {
        setUploadedFiles([...uploadedFiles, ...uploadedFilesData]);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: getObservation } = useHttp();
  const { sendRequest: getFinishProducts } = useHttp();

  const handleLotIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;
    const data = lotData && lotData.filter((item) => item.stockId == id);
    frmRef.current.product_name.value = data[0] && data[0].productName;
    frmRef.current.avl_qty.value =
      data[0] &&
      data[0].productQuantityBal + " " + data[0].productunitAbbreviation;
    frmRef.current.crop_name.value = data[0] && data[0].productSubTypeName;
    frmRef.current.variety.value = data[0] && data[0].productTypeName;

    //console.log("data", data);
    const varietyId = data[0] && data[0].varietyId;
    if (varietyId) {
      getObservation(
        {
          url: `/api/varietywiseSeedQualityParamter/?orgId=${localStorage.getItem(
            "orgId"
          )}&varietyId=${varietyId}`,
        },
        (data) => {
          //console.log(data);
          setObservationDetails(data);
        }
      );

      getFinishProducts(
        {
          url: `/api/getFinishGoodsProduct/?orgId=${localStorage.getItem(
            "orgId"
          )}&varietyId=${varietyId}`,
        },
        (data) => {
          //console.log(data);
          setFinishProducts(data.seedProductList);
        }
      );
    }
  };

  const maxObservationLength =
    ObservationDetails &&
    Math.max(
      ...ObservationDetails.map((itm) =>
        itm.observationSubParamter ? itm.observationSubParamter.length : 0
      )
    );
  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          const filteredUnits =
            res && res.filter((item) => item.unitTypeId == 2);

          setUnits(filteredUnits);
        }
      }
    );
  }, [getunits]);

  const handleSeedCountChange = (e, index) => {
    const newValue = e.target.value;

    setObservationDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].seedCount = newValue;
      //  //console.log(updatedDetails);
      return updatedDetails;
    });
  };

  const handleSampleSize = (e, index) => {
    const newValue = e.target.value;

    setObservationDetails((prevDetails) => {
      const updatedDetails = [...prevDetails];
      updatedDetails[index].sampleSizegm = newValue;
      return updatedDetails;
    });
  };

  const handleObservationChange = (e, rowIdx, subParamIdx) => {
    const { value } = e.target;
    const updatedDetails = [...ObservationDetails];
    updatedDetails[rowIdx].observationSubParamter[subParamIdx].value = value;
    //console.log(updatedDetails);
    setObservationDetails(updatedDetails);

    setObservationDetails(
      ObservationDetails &&
        ObservationDetails.map((x) => ({
          ...x,
          observation: x.observationSubParamter,
          remark: "",
        }))
    );
  };

  const { sendRequest: postLabTest } = useHttp();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (ObservationDetails && ObservationDetails.length === 0) {
      toast.error("Observation Paramter required");
      return;
    }

    setLoading(true);
    const data = {
      seedLabTestDate: moment(frmRef.current.test_date.value).format(
        "DD/MM/YYYY"
      ),
      timeStamp: frmRef.current.inspection_time.value,
      supervisorEmployeeId: frmRef.current.inspected_by.value,
      stockId: frmRef.current.lot_id.value,
      temperature: frmRef.current.temp.value,
      finishProductId: frmRef.current.finish_product_name.value,
      sampleQty: frmRef.current.sample_qty.value,
      unitId: frmRef.current.unit.value,
      result: frmRef.current.result.value,
      attachmentUrl: uploadedFiles,
      paramterDetail: ObservationDetails,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      reamrk: "",
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    //console.log(data);
    postLabTest(
      {
        url: "/api/seedLabTest/",
        method: "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(`Lab Testing done successfully`);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={handleSubmit}>
                <div className="card-header">
                  <h3 className="card-title">
                    Sample Seed Testing by Labs Form
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"dpi_date"}> {"Seed Qc Date"}</label>
                      <input
                        type={"date"}
                        id={"test_date"}
                        required
                        ref={(el) => (frmRef.current["test_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspection_time"}>
                        {" "}
                        {"Inspection Time "}
                      </label>
                      <input
                        type={"time"}
                        id={"inspection_time"}
                        required
                        ref={(el) => (frmRef.current["inspection_time"] = el)}
                        defaultValue={getCurrentTime()}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"inspected_by"}>{"Inspected By"}</label>
                      <select
                        id="inspected_by"
                        className="form-control"
                        ref={(el) => (frmRef.current["inspected_by"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              key={x.empId}
                              selected={
                                props.update &&
                                props.update.supervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"lot_id"}> {"Lot Id "}</label>
                      <select
                        id="lot_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["lot_id"] = el)}
                        required
                        onChange={handleLotIdChange}
                      >
                        <option value="">Select</option>
                        {lotData &&
                          lotData.map((x) => (
                            <option value={x.stockId}>{x.lotNo}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Product Name"}> {"Product Name"}</label>
                      <input
                        type={"text"}
                        id={"product_name"}
                        required
                        ref={(el) => (frmRef.current["product_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"crop_name"}> {"Crop Name"}</label>
                      <input
                        type={"text"}
                        id={"crop_name"}
                        required
                        ref={(el) => (frmRef.current["crop_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Product Name"}> {"Variety"}</label>
                      <input
                        type={"text"}
                        id={"variety"}
                        required
                        ref={(el) => (frmRef.current["variety"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"avl_qty"}> {"Available Quantity"}</label>
                      <input
                        type={"text"}
                        id={"avl_qty"}
                        min="0"
                        required
                        ref={(el) => (frmRef.current["avl_qty"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"shelf_life"}>{"Temperature(°C)"}</label>
                      <input
                        type={"number"}
                        id={"temp"}
                        required
                        ref={(el) => (frmRef.current["temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"sample_qty"}>
                        {" "}
                        {"Total Sample Qty"}
                      </label>
                      <input
                        type={"text"}
                        id={"sample_qty"}
                        required
                        ref={(el) => (frmRef.current["sample_qty"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"unit"}> {"Unit"}</label>
                      <select
                        id="unit"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["unit"] = el)}
                      >
                        <option selected disabled value="">
                          Select
                        </option>

                        {units &&
                          units.map((x) => (
                            <option value={x.unitId}>{x.unitName}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"observation_paramter"}>
                        {" "}
                        {"Observation Paramter"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"observation_paramter"}
                        autoComplete="off"
                        ref={(el) =>
                          (frmRef.current["observation_paramter"] = el)
                        }
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setIsObservationOpen(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"result"}>{"Result"}</label>
                      <select
                        id="result"
                        className="form-control"
                        ref={(el) => (frmRef.current["result"] = el)}
                        required
                        onChange={(e) => setSelectedResult(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="pass">Pass</option>
                        <option value="fail">Fail</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"finish_product_name"}>
                        {"Finish Group Product Name"}
                      </label>
                      <select
                        id="finish_product_name"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["finish_product_name"] = el)
                        }
                        required
                        disabled={selectedResult == "fail" ? false : true}
                      >
                        <option value="">Select</option>
                        {finishProducts &&
                          finishProducts.map((x) => (
                            <option value={x.productId} key={x.productId}>
                              {x.productName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Attachment"}>{"Attachment"}</label>
                      <label className="custom-file-upload">
                        <input
                          type="file"
                          id={"attachment"}
                          ref={(el) => (frmRef.current["attachment"] = el)}
                          className="form-control"
                          multiple
                          onChange={handleAttachmentChange}
                        />
                      </label>
                    </div>
                  </div>
                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {isObservationOpen && (
        <Modal isOpen={true} style={modalStyles2}>
          <form>
            <h3 className="card-title">Observation Paramter Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsObservationOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>

            <div>
              <table className="table table-sm  table-responsive table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr No</th>
                    <th>Paramter Name</th>
                    <th>Sample Size</th>
                    <th>Seed Count</th>
                    <th colSpan={maxObservationLength}>Observation</th>
                  </tr>
                </thead>
                <tbody>
                  {ObservationDetails &&
                    ObservationDetails.map((itm, i) => {
                      return (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{itm.parameterName}</td>
                          <td>
                            <input
                              type="text"
                              id={`sample_size-${i}`}
                              required
                              ref={(el) =>
                                (frmRef.current[`sample_size-${i}`] = el)
                              }
                              className="form-control"
                              value={itm.sampleSizegm || ""}
                              onChange={(e) => handleSampleSize(e, i)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              id={`seed_count-${i}`}
                              required
                              ref={(el) =>
                                (frmRef.current[`seed_count-${i}`] = el)
                              }
                              className="form-control"
                              value={itm.seedCount || ""}
                              onChange={(e) => handleSeedCountChange(e, i)}
                            />
                          </td>

                          {itm.observationSubParamter &&
                            itm.observationSubParamter.map((item, index) => {
                              return (
                                <td>
                                  {item.headerText}
                                  <input
                                    type="text"
                                    value={item.value || 0}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleObservationChange(e, i, index)
                                    }
                                  />
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            <br />
            <div className="text-center">
              <button
                type="submit"
                className="btn btn-sm btn-primary"
                onClick={() => setIsObservationOpen(false)}
              >
                Save
              </button>
            </div>
          </form>
        </Modal>
      )}
    </>
  );
};

export default LabTestingForm;
